/**
 *  TileBg1
 *
 *  Created by Legman on 13/03/2017.
 *
 */

import BaseTile from "./BaseTile";
import Common   from "./Common";

/**
 * @class
 */
export default class TileBg1 extends BaseTile {
    constructor() {
        const assets = Common.assets;

        super(assets.getTexture("tile_004"));

        this.view.anchor = new PIXI.Point();

        let light = this.createLight();
        light.y = Common.STAGE_HEIGHT * 0.5;
    }
}
